let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ibz6c")).then(() => parcelRequire('hW2zm'));